export default __webpack_public_path__ + "static/KoiFishInPondAndreattaWaterscapesCentralPointOregon-ccef2b4f7ce13f2d39e4a7764af7fc08.mp4";